"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shapes = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex\n  align-items: center\n  flex-direction: column\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0\n  height: ", "\n  width: ", "\n  display: flex\n  align-items: center\n  justify-content: center\n  background-color: transparent\n  border: 1px solid ", "\n  transition: border .1s ease\n  cursor: pointer\n\n  &, &:active, &:hover, &:focus {\n    text-decoration: none\n  }\n\n  &:hover {\n    border: 1px solid ", "\n  }\n\n  &:active {\n    border: 1px solid ", "\n  }\n\n  svg {\n    color: ", "\n\n    &:focus {\n      color: ", "\n    }\n\n    &:hover {\n      color: ", "\n\n    }\n\n    &:active {\n      color: ", "\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0\n  height: ", "\n  width: ", "\n  display: flex\n  align-items: center\n  justify-content: center\n  color: #FFFFFF\n  border-radius: 50%\n  border: none\n  background-color: ", "\n  transition: background-color .1s ease\n  cursor: pointer\n\n  &, &:active, &:hover, &:focus {\n    color: #FFFFFF\n    text-decoration: none\n  }\n\n  &:hover {\n    background-color: ", "\n    color: #FFFFFF\n  }\n\n  &:active {\n    background-color: ", "\n    color: #FFFFFF\n  }\n\n  &:focus {\n    box-shadow: ", "\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", "\n  font-weight: normal\n  padding: 3px 8px\n  display: flex\n  align-items: flex-end\n  background-color: transparent\n  cursor: pointer\n  width: 100px\n  color: ", "\n  font-size: 12px\n\n  &, &:active, &:hover, &:focus {\n    color: ", "\n    text-decoration: none\n  }\n\n  &:hover {\n    border-color: ", "\n    color: ", "\n  }\n\n  &:active {\n    border-color: ", "\n    color: ", "\n  }\n\n  svg {\n    width: auto\n    height: 16px\n    margin-right: 10px\n  }\n\n  span {\n    flex: 1 1 0\n    text-align: center\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative\n  border: 1px solid ", "\n  font-weight: normal\n  padding: 0\n  display: flex\n  align-items: center\n  background-color: ", "\n  border-radius: 50px\n  cursor: pointer\n  flex: 1\n  height: ", "\n\n  &, &:active, &:hover, &:focus {\n    color: #FFF\n    text-decoration: none\n  }\n\n  &:hover {\n    background-color: ", "\n  }\n\n  &:active {\n    background-color: ", "\n  }\n\n  &:focus {\n    box-shadow: ", "\n  }\n\n  ", "\n\n  div {\n    border-radius: 50%\n    border: 1px solid #FFF\n    height: 56px\n    width: 56px\n    display: flex\n    align-items: center\n    justify-content: center\n    position: relative\n    left: -2px\n\n    svg {\n      width: 25px\n      height: 25px\n    }\n  }\n\n  span {\n    flex: 1 1 0\n    font-size: 18px\n    font-weight: 600\n    padding: 0 20px 0 10px\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var fullSize = '56px';
var roundSize = '45px';
var squareSize = '30px';

var ButtonFull = _styledComponents["default"].a(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, fullSize, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.activeColor;
}, function (props) {
  return props.boxShadow ? 'rgba(0, 0, 0, 0.2) 0px 3px 3px 0px, 0.2rem 0.2rem 0.2rem 0 rgba(0, 0, 0, 0.1) inset' : '0.2rem 0.2rem 0.2rem 0 rgba(0, 0, 0, 0.1) inset';
}, function (props) {
  return props.boxShadow ? 'box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 3px 0px' : '';
});

var ButtonMinimal = _styledComponents["default"].a(_templateObject2(), function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.activeColor;
}, function (props) {
  return props.activeColor;
});

var ButtonRound = _styledComponents["default"].a(_templateObject3(), roundSize, roundSize, function (props) {
  return props.color;
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.activeColor;
}, function (props) {
  return props.boxShadow ? 'rgba(0, 0, 0, 0.2) 0px 3px 3px 0px, 0.2rem 0.2rem 0.2rem 0 rgba(0, 0, 0, 0.1) inset' : '0.2rem 0.2rem 0.2rem 0 rgba(0, 0, 0, 0.1) inset';
}, function (props) {
  return props.boxShadow ? 'box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 3px 0px' : '';
});

var ButtonSquare = _styledComponents["default"].a(_templateObject4(), squareSize, squareSize, function (props) {
  return props.color;
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.activeColor;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.activeColor;
});

var LabelWrapper = _styledComponents["default"].div(_templateObject5()); // Grab `className` from original shape and apply it to the wrapper instead.
// This is helpful when some `.display-none` is applied, b/c the label has to
// be hidden as well.


var ButtonRoundWithLabel = function ButtonRoundWithLabel(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/_react["default"].createElement(LabelWrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(ButtonRound, props), props.label);
};

var shapes = {
  'full': ButtonFull,
  'minimal': ButtonMinimal,
  'round': ButtonRound,
  'square': ButtonSquare,
  'roundWithLabel': ButtonRoundWithLabel
};
exports.shapes = shapes;